module.exports = __webpack_public_path__ + "static/media/versions.99af63e2.svg";